var _ellipse, _path, _ellipse2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.7403,
    cy: 18.7574,
    rx: 10.0253,
    ry: 3.12604,
    transform: "rotate(130.737 11.7403 18.7574)",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9111 21.9189C24.9062 18.0664 24.353 14.193 23.1479 10.9954C23.0931 10.8508 22.9975 10.7557 22.8652 10.7065C21.5706 10.2237 16.7403 14.1886 12.0105 19.4058C7.03558 24.8929 3.59654 30.1189 4.03813 31.4473C4.05921 31.5108 4.08612 31.5681 4.12535 31.6132C6.63063 34.5185 13.5943 34.5802 18.7521 30.1578",
    stroke: "#00212E",
    strokeWidth: 1.66667
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 35.9997,
    rx: 14,
    ry: 4,
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56011 32.1422C6.52355 30.8537 9.10482 29.0894 11.2209 27.1614C17.0576 21.8432 20.8576 15.8818 23.2836 11.1497",
    stroke: "#00212E",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7575 22.9078C19.8756 23.275 17.1635 24.0228 16.8095 24.9353C16.784 25.0009 16.7666 25.0668 16.7659 25.1344C16.7173 29.8487 22.7441 36.5398 30.26 36.6549C37.7765 36.7701 42.0586 31.3599 43.9647 25.8279C44.0183 25.6726 44.0096 25.52 43.9453 25.3709C43.3108 23.9061 37.2234 22.7743 30.4023 22.6701C27.9904 22.633 25.7235 22.7216 23.7575 22.9078",
    stroke: "#00212E",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7656 25.6615C18.9684 26.2593 21.9064 27.0025 24.6139 27.3194C32.0799 28.1934 38.4858 27.2468 43.1488 26.0796",
    stroke: "#00212E",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLenses);
export default __webpack_public_path__ + "static/media/lenses.381da98cda40b6fa62345ba93d811fff.svg";
export { ForwardRef as ReactComponent };